import { MenuItem } from 'primeng/api';

export const ItemsLayoutMainOptions: MenuItem[] = [
  {
    automationId: 'PR_002',
    label: 'menu_main.products',
    icon: 'pi pi-fw pi-tags',
    routerLink: 'products/list',
    tooltip: 'main_layout.products_description',
  },
  {
    automationId: 'IM_004',
    label: 'menu_main.inventories',
    icon: 'pi pi-fw pi-calculator',
    routerLink: 'inventories/summary-list',
    tooltip: 'main_layout.inventories_description',
  },
  {
    automationId: 'MV_001',
    label: 'menu_main.movements',
    icon: 'pi pi-fw pi-arrow-right-arrow-left',
    routerLink: 'moves/list',
    tooltip: 'main_layout.movements_description',
  },
  {
    automationId: 'SO_002',
    label: 'menu_main.store_orders',
    icon: 'pi pi-fw pi-cart-plus',
    routerLink: 'operations/store-orders/list',
    tooltip: 'main_layout.store_orders_description',
  },
  {
    automationId: 'SO_002',
    label: 'menu_main.quotes',
    icon: 'pi pi-fw pi-receipt',
    routerLink: 'budgets/list',
    tooltip: 'main_layout.quotes_description',
  },
  {
    automationId: 'MA_001',
    label: 'menu_main.maintenances',
    icon: 'pi pi-fw pi-cog',
    routerLink: 'maintenance/work-orders-management',
    tooltip: 'main_layout.maintenances_description',
  },
  {
    automationId: 'AST_AUTH_000',
    label: 'menu_main.authorizations',
    icon: 'pi pi-fw pi-shield',
    routerLink: 'authorizations/list',
    tooltip: 'main_layout.authorizations_description',
  },
  {
    automationId: 'AD_002',
    label: 'menu_main.inventory',
    icon: 'pi pi-fw pi-calculator',
    routerLink: 'audits/list',
    tooltip: 'main_layout.inventory_description',
  },
];

/**
 * Array objects for main-sibedar menu
 * @type {MenuItem[]} Array for objects compatible with menu primeng
 *
 */
export const ItemsMenu: MenuItem[] = [
  {
    label: 'menu_main.dashboards',
    icon: 'pi pi-fw pi-chart-line',
    visible: true,
    routerLink: 'dashboards',
    items: [],
  },
  {
    automationId: 'CT_000',
    label: 'menu_main.thirds',
    icon: 'pi pi-fw pi-users',
    items: [
      {
        automationId: 'CT_001',
        label: 'menu_main.thirds_new',
        icon: 'pi pi-fw pi-user-plus',
        routerLink: 'third-party/create',
      },
      {
        automationId: 'CT_002',
        label: 'menu_main.thirds_list',
        icon: 'pi pi-fw pi-list',
        routerLink: 'third-party/list',
      },
    ],
  },
  {
    automationId: 'PR_000',
    label: 'menu_main.operations',
    icon: 'pi pi-fw pi-briefcase',
    visible: true,
    items: [
      {
        automationId: 'PR_000',
        label: 'menu_main.products',
        icon: 'pi pi-fw pi-tags',
        items: [
          {
            automationId: 'PR_002',
            label: 'menu_main.products_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'products/list',
          },
          {
            automationId: 'IM_006',
            label: 'Desactivar Tags',
            icon: 'pi pi-fw pi-tag',
            routerLink: 'products/item-inactive',
          },
        ],
      },
      {
        automationId: 'IM_000',
        label: 'menu_main.inventories',
        icon: 'pi pi-fw pi-calculator',
        visible: true,
        items: [
          {
            automationId: 'IM_004',
            label: 'menu_main.inventory_dashboards',
            icon: 'pi pi-fw pi-chart-bar',
            routerLink: 'inventories/dashboards',
          },
          {
            automationId: 'IM_004',
            label: 'menu_main.inventory_summary',
            icon: 'pi pi-fw pi-table',
            routerLink: 'inventories/summary-list',
          },
          {
            automationId: 'IM_006',
            label: 'menu_main.inventory_store_summary',
            icon: 'pi pi-fw pi-building',
            routerLink: 'inventories/store-summary',
          },
          {
            automationId: 'IM_005',
            label: 'menu_main.inventory_booking',
            icon: 'pi pi-fw pi-calendar',
            routerLink: 'inventories/booking/list',
          },
          {
            automationId: 'MV_001',
            label: 'menu_main.movements',
            icon: 'pi pi-fw pi-arrow-right-arrow-left',
            routerLink: 'moves/list',
          },
        ],
      },
      {
        automationId: 'PO_000',
        label: 'menu_main.receiving',
        icon: 'pi pi-fw pi-truck',
        items: [
          {
            automationId: 'PO_001',
            label: 'menu_main.production_orders',
            icon: 'pi pi-fw pi-cart-plus',
            items: [
              {
                automationId: 'PO_002',
                label: 'menu_main.production_order_create',
                icon: 'pi pi-fw pi-plus-circle',
                routerLink: 'production-orders/create',
              },
              {
                automationId: 'PO_003',
                label: 'menu_main.production_order_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'production-orders/list',
              },
            ],
          },
          {
            automationId: 'PUO_001',
            label: 'menu_main.purchase_orders',
            icon: 'pi pi-fw pi-cart-plus',
            items: [
              {
                automationId: 'PUO_001',
                label: 'menu_main.purchase_order_create',
                icon: 'pi pi-fw pi-plus-circle',
                routerLink: 'purchase-orders/create',
              },
              {
                automationId: 'PUO_002',
                label: 'menu_main.purchase_order_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'purchase-orders/list',
              },
            ],
          },
          {
            automationId: 'PRNT_002',
            label: 'menu_main.print_orders',
            icon: 'pi pi-fw pi-print',
            routerLink: 'print-orders/list',
          },
        ],
      },
      {
        automationId: 'OP_000',
        label: 'menu_main.orders',
        icon: 'pi pi-fw pi-file',
        items: [
          {
            automationId: 'SO_000',
            label: 'menu_main.quotes',
            icon: 'pi pi-fw pi-receipt',
            items: [
              {
                automationId: 'SO_001',
                label: 'menu_main.quotes_create',
                icon: 'pi pi-fw pi-plus-circle',
                routerLink: 'budgets/create',
              },
              {
                automationId: 'SO_002',
                label: 'menu_main.quotes_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'budgets/list',
              },
            ],
          },
          {
            automationId: 'SO_000',
            label: 'menu_main.store_orders',
            icon: 'pi pi-fw pi-cart-plus',
            items: [
              {
                automationId: 'SO_001',
                label: 'menu_main.store_order_create',
                icon: 'pi pi-fw pi-plus-circle',
                routerLink: 'operations/store-orders/create',
              },
              {
                automationId: 'SO_002',
                label: 'menu_main.store_order_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'operations/store-orders/list',
              },
            ],
          },
          {
            automationId: 'DT_000',
            label: 'menu_main.distributions',
            icon: 'pi pi-fw pi-list',
            items: [
              {
                automationId: 'DT_001',
                label: 'menu_main.distribution_order_create',
                icon: 'pi pi-fw pi-plus-circle',
                routerLink: 'operations/distribution-orders/create',
              },
              {
                automationId: 'DT_002',
                label: 'menu_main.distribution_order_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'operations/distribution-orders/list',
              },
            ],
          },
          {
            automationId: 'WO_000',
            label: 'menu_main.work_orders',
            icon: 'pi pi-fw pi-file-edit',
            items: [
              {
                automationId: 'WO_001',
                label: 'menu_main.work_order_create',
                icon: 'pi pi-fw pi-plus-circle',
                routerLink: 'operations/work-orders/create',
              },
              {
                automationId: 'WO_002',
                label: 'menu_main.work_order_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'operations/work-orders/list',
              },
            ],
          },
          {
            automationId: 'PK_000',
            label: 'menu_main.packings',
            icon: 'pi pi-fw pi-box',
            items: [
              {
                automationId: 'PK_003',
                label: 'menu_main.packing_list_states',
                icon: 'pi pi-fw pi-box',
                routerLink: 'packings/list-states',
              },
              {
                automationId: 'PK_003',
                label: 'menu_main.packing_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'packings/list',
              },
            ],
          },
        ],
      },
      {
        automationId: 'MA_000',
        label: 'menu_main.maintenances',
        icon: 'pi pi-fw pi-cog',
        items: [
          {
            automationId: 'MA_001',
            label: 'menu_main.maintenance_planner',
            icon: 'pi pi-fw pi-book',
            routerLink: 'maintenance/planner-list',
          },
          {
            automationId: 'MA_001',
            label: 'menu_main.maintenance_tree_task_groups',
            icon: 'pi pi-fw pi-sitemap',
            routerLink: 'maintenance/event-task-groups',
          },
          {
            automationId: 'MA_001',
            label: 'menu_main.maintenance_work_orders',
            icon: 'pi pi-fw pi-list',
            routerLink: 'maintenance/work-orders-management',
          },
          {
            automationId: 'SVC_001',
            label: 'menu_main.services',
            icon: 'pi pi-fw pi-receipt',
            routerLink: 'invoicing/services',
          },
        ],
      },
      {
        automationId: 'AST_AUTH_000',
        label: 'menu_main.authorizations',
        icon: 'pi pi-fw pi-shield',
        items: [
          {
            automationId: 'AST_AUTH_001',
            label: 'menu_main.create_authorization',
            icon: 'pi pi-fw pi-plus-circle',
            routerLink: 'authorizations/create',
          },
          {
            automationId: 'AST_AUTH_002',
            label: 'menu_main.authorization_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'authorizations/list',
          },
        ],
      },
      {
        automationId: 'AD_000',
        label: 'menu_main.inventory',
        icon: 'pi pi-fw pi-calculator',
        items: [
          {
            automationId: 'AD_001',
            label: 'menu_main.inventory_counts_programming',
            icon: 'pi pi-fw pi-calendar-clock',
            routerLink: 'audits/calendar',
          },
          {
            automationId: 'AD_002',
            label: 'menu_main.inventory_counts_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'audits/list',
          },
          {
            automationId: 'AUD_004',
            label: 'menu_main.inventory_variable_counts',
            icon: 'pi pi-fw pi-calendar-times',
            routerLink: 'inventories-counts',
          },
          {
            automationId: 'AUD_004',
            label: 'menu_main.inventory_variable_counts_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'inventories-counts/list-counts',
          },
        ],
      },
    ],
  },
  {
    automationId: 'RFID_APPS_000',
    label: 'menu_main.rfid_apps',
    icon: 'pi pi-fw pi-wifi',
    visible: true,
    items: [
      {
        automationId: 'SCT_001',
        label: 'menu_main.screens',
        icon: 'pi pi-fw pi-desktop',
        routerLink: 'screen-control',
      },
    ],
  },
  {
    automationId: 'SETT_000',
    label: 'menu_main.settings',
    icon: 'pi pi-fw pi-cog',
    visible: true,
    items: [
      {
        automationId: 'LOC_000',
        label: 'menu_main.locations_management',
        icon: 'pi pi-fw pi-map-marker',
        items: [
          {
            automationId: 'LOC_001',
            label: 'menu_main.warehouse_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'locations/warehouses/list',
          },
          {
            automationId: 'LOC_002',
            label: 'menu_main.warehouse_create',
            icon: 'pi pi-fw pi-plus-circle',
            routerLink: 'locations/warehouses/create',
          },
          {
            automationId: 'LOC_001',
            label: 'menu_main.locations_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'locations/ubicaciones/list',
          },
          {
            automationId: 'LOC_002',
            label: 'menu_main.locations_create',
            icon: 'pi pi-fw pi-plus-circle',
            routerLink: 'locations/ubicaciones/create',
          },
          {
            automationId: 'LOC_003',
            label: 'menu_main.locations_batch_create',
            icon: 'pi pi-fw pi-objects-column',
            routerLink: 'locations/ubicaciones/batch-create',
          },
        ],
      },
    ],
  },
];
